@if (!isModernBrowser()) {
    <div class="page-wrapper outdated-browser-container">
        <sfx-logo path="swissfex.svg#swissfex"></sfx-logo>
        <div>{{ 'global.browser_not_supported' | translate }}</div>
    </div>
} @else if (isAppLoading()) {
    <div class="page-wrapper">
        <sfx-loader></sfx-loader>
    </div>
} @else {
    <router-outlet></router-outlet>
}

@if (areDiagnosticsEnabled()) {
    <div class="diagnostic-logs">
        <sfx-list
            [items]="diagnosticLogsListItems$ | async | slice: 0 : 10"
            bullet="-"
        >
            <ng-template
                #listItem
                let-item
            >
                {{ item.date }}: {{ item.key }} - {{ item.value }}
            </ng-template>
        </sfx-list>

        <sfx-button
            type="main"
            (clicked)="disabledDiagnostics()"
            label="Close"
        ></sfx-button>
    </div>
}
